import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, IconButton } from "@mui/material";
import { GridPagination } from "@mui/x-data-grid";
import React from "react";

type TableCustomFooterProps = {
  onRefresh: () => void;
  isLoading: boolean;
};

const TableCustomFooter: React.FC<TableCustomFooterProps> = ({ onRefresh, isLoading }) => (
  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 1, borderTop: 1, borderColor: "divider" }}>
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <IconButton onClick={onRefresh} disabled={isLoading} title="Refresh data" aria-label="refresh data" size="small">
        <RefreshIcon />
      </IconButton>
    </Box>
    <GridPagination showFirstButton showLastButton />
  </Box>
);

export default TableCustomFooter;
